var msg = new Array();
msg['ERR_CARRIERMISSING']='Vous devez sélectionner un type d\'livraison.';
msg['ERR_CARRIER_COST_MISSING']='Pas de frais de disponibles pour le pays sélectionné et le poids de la commande.';
msg['ERR_CLIENTMANDATORYFIELDS']='*Les champs marqués en rouge sont obligatoires';
msg['ERR_FILLEMAILFIELD']='Remplissez dans le champ email.';
msg['ERR_INVALIDMAIL']='Adresse e-mail invalid.';
msg['ERR_LOGININVALID']='E-mail ou mot de passe incorrecte';
msg['ERR_LOGINREQUIRED']='Vous devez vous identifier d\'abord';
msg['ERR_MISSINGFIELDS']='Remplissez tous les champs obligatoires.';
msg['ERR_NOSIZESELECTED']='Vous devez choisir la taille';
msg['ERR_PRIVACY']='Vous devez accepter la déclaration de protection des données.';
msg['ERR_USEREXISTS']='Utilisateur existant.';
msg['LABEL_ALREADYREGISTEREDUSERES']='Already registered users';
msg['LABEL_ARTICLES']='articles';
msg['LABEL_INVITES_ALREADY_SENT']='Users already invited';
msg['LABEL_NOTAPPLICABLE']='Non appliquable';
msg['LABEL_NOTSENTINVITES']='Unsent invites';
msg['LABEL_SELECTALL']='Select all';
msg['LABEL_SENTINVITES']='Sent invites';
msg['LABEL_SUBMIT']='Submit';
msg['LABEL_WARNING']='Avertissement';
msg['MSG_ADDEDTOCART']='Produits ajoutés à votre panier';
msg['MSG_ADDEDTOWISHLIST']='Produit ajouté à votre liste de souhaits';
msg['MSG_APPLIEDVATCHANGED']= 'Après la mise à jour des donnés de facturation, la TVA appliquée à votre commande a changé. Vérifiez le nouveau montant de que la page a été rechargé.';
msg['MSG_COUPON_ERROR']='Code coupon inséré pas valide ou déjà inséré précédemment.';
msg['MSG_COUPON_VALID']='Code coupon inséré validé avec succès.';
msg['MSG_DEFERRED_DISPATCH_COMPUTATION']='Seul la commande en mode de réservation sera activée et les frais de livraison seront vous envoyés par e-mail.';
msg['MSG_EXTRAUELIMIT']='Le montant minimum de votre commande ne peut pas être inferieur à 2000.00 &euro;';
msg['MSG_GENERIC_ERROR']='Désolés, une erreur s\'est produite.';
msg['MSG_INSUFFICIENT_STOCK']='Désolés, pour le moment nous n\'avons pas assez de disponibilité des produits.';
msg['MSG_MAILSENT']='E-mails envoyés';
msg['MSG_MESSAGE_PRODUCTSHARE']='Message';
msg['MSG_MESSAGE_SENT']='Message envoyé!';
msg['MSG_MIXED_CART']='ce produit ne peut pas être mélangés avec les produits que sont dans le panier, parce qu’ il se trouve dans un autre entrepôt.';
msg['MSG_MIXED_INTANGIBLE']='La vente à laquelle appartiennent les produits dans le panier ne peut pas être placés dans le panier avec ce produit.';
msg['MSG_PAYMENT_PENDING'] = 'Paiement en attente de validation';
msg['MSG_PROFILECONSENT_SAVED'] = 'Vos préférences de contact ont été mises à jour';
msg['MSG_RECOVEREMAILSENT']='Contrôlez votre boîte de réception et cliquez sur le lien pour confirmer le changement.';
msg['MSG_RECOVEREMAILSENT_ERROR']='Attention: vous n\'êtes pas enregistré avec cet adresse email ou que vous réinitialisez déjà votre mot de passe.';
msg['MSG_RETURN_REQUEST_SUCCESS'] = 'Demande de retour créé avec succès';
msg['MSG_RULE_REJECT']='Product cannot be added to cart because of rule :rule';
msg['MSG_SAVE_SUCCESS'] = 'Sauver avec succès';
msg['MSG_SELECT_PROVINCE']='Choose a province';
msg['MSG_SENDER_PRODUCTSHARE']='Votre nom';
msg['MSG_SUBJECT_PRODUCTSHARE']=' partagé quelque chose avec vous';
msg['MSG_SUBSCRIBED'] = 'Iscritto con successo';
msg['MSG_SUBSCRIPTION_FAILURE']='Make sure you do not have any other active subscription.';
msg['MSG_SUBSCRIPTION_NO_RENEWABLE'] = 'L\'abonnement n\'est plus renouvelable, trop de jours sont passé.';
msg['MSG_WAIT']='Attendre...';
msg['msg.form.invalidtype'] = 'Une erreur s\'est produite. Veuillez contacter l\'administration en signalant l\'erreur suivante : "Type de contact invalide ou manquant."';
msg['msg.form.invalidemail'] = 'Email invalide ou manquant';
msg['msg.form.invalidrecipients'] = 'Une erreur s\'est produite. Veuillez contacter l\'administration en signalant ce qui suit : "Destinataires du contact invalides ou absents."';

var portal_livestock_available='AVAILABLE';
var portal_livestock_soldout='SOLD OUT';

var activity_online_shop = 'shop en ligne';
var activity_shop = 'magasin';
var activity_private_sales = 'ventes privèes';
var activity_outlet = 'outlet';
var activity_online_outlet = 'outlet en line';
var activity_store_chain = 'chaine de magasins';
var activity_purchasing_group = 'group d\'achat';
var activity_broker = 'broker/agent';
var activity_ebay_amazon = 'magasin ebay/amazon';
var activity_other = 'autre';

var general='General';
var general_personaldata='Personal data';
var general_olduser='Registered user';
var general_newuser='New user';
var general_username="Username";
var general_password="Password";
var general_contacts='Contacts';
var general_phone='Phone Nr';
var general_skype='Skype';
var general_website='WebSite';
var general_fax='Fax';
var general_firstname='First name';
var general_lastname='Last name';
var general_company='Company';
var general_birth='Date of birth';
var general_code='Code';
var general_model='Model';
var general_quantity='Quantity';
var general_availability='Availability';
var general_price='Price';
var general_warning='Warning';
var general_dispatchto='Nom de la société/Destinataire';
var general_careof='C/O';
var general_vat='VAT';
var general_address='Address';
var general_addresstype='Address type';
var general_addressnumber='Number';
var general_city='City';
var general_prov='Prov';
var general_zip='ZIP';
var general_mobile='Mobile';
var general_notes='Notes';
var general_orders='Commandes';
var general_fgfdiscounts='Friends and discounts';
var general_myprofile='My Profile';
var general_pieces='pc';
var general_size_table='Size Table';
var general_details='Details';
var general_invoice='Invoice';
var general_creditnote='Note de crédit';
var general_cart= 'Shopping Cart';
var general_country='Country';
var general_carrier='Carrier';
var general_dispatch_address='Dispatch Address';
var general_invoice_address='Invoice Address';
var general_receive_newsletter='Receive newsletter';
var general_copydispatchfrombilldata='Copiez-vous des données de facturation';
var general_instructions="Instructions";
var general_add="Ajouter";
var general_status="Status";
var general_toomanyfilters="Hai raggiunto il numero massimo di filtri permessi.";

var help_addresstype='Via, Piazza, Corso, ...';
var help_address='Street name';
var help_dispatchmobile='This number will be used by the carrier.';
var help_ordercfpiva='A blank value will automatically add a 20% VAT to the order value.';
var help_cf='Insert your SSN';

var buttons_save='Save';
var buttons_changepw='Change password';
var buttons_close='Close';
var buttons_continue='Continue';
var buttons_confirm='Confirm';
var buttons_cancel='Cancel';
var buttons_invite='Invita';
var buttons_continueshopping='Continue with shopping';
var buttons_gocheckout='Valider';

var messages_product_soldout='Product sold out.';
var messages_noselection='No selection';
var messages_invaliddata='Invalid data.';
var messages_recoverpassword='Recover password';
var messages_recoverpassword_info='Insert the email you subscribed with<br/>You will receive an email with the istructions to get a recover your password';
var messages_invitefriends='Invite your friends';
var messages_confirmpassword='Confirm password';
var messages_sendingmail='Sending mail...';
var messages_mailsent='Email sent.';
var messages_password='Password';
var messages_confirmpassword='Password confirm';
var messages_requiredfield='Champ obligatoir';

var subscribe_personaldata='Personal data';
var subscribe_privacyintro='You have to accept the following condition to proceed with the subscription.';
var subscribe_privacydisclaimer='You have to accept the privacy displaimer to proceed with the subscription.'
var subscribe_privacy1='I accept the pricacy disclaimer';
var subscribe_privacy2='I accept that my personal data can be used by other firms for marketing campaigns (optional)';

var order_status='Status'
var order_date='Date'
var order_dispatchdate='Dispatched';

var returnedgoods_requests="Demands de merchandise en retour";
var returnedgoods_motivations="Motivation du retour";
var returnedgoods_requestcode="Code de la merchandise en retour";
var returnedgoods_requestdate="Date de la demande";
var returnedgoods_motivations_1="Le produit n'est pas à mon goût";
var returnedgoods_motivations_2="Le produit est trop grand/petit";
var returnedgoods_motivations_3="Le produit est endommagè";
var returnedgoods_motivations_4="Le produit reçu ne correspond pas au produit demandè";
var returnedgoods_motivations_5="Le produit n'est pas inclus dans l'emballage";
var returnedgoods_motivations_other="Autre";
